import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../common/redux/store';
import { DEFAULT_SEARCH_VALUE } from './constant';
import { IGroupPolicySearchParams, IGroupPolicySearchState } from './interface';

const initialState: IGroupPolicySearchState = {
  searchValue: DEFAULT_SEARCH_VALUE,
  listIdDelete: [],
  showPopup: false,
};

export const listGroupPolicyReducer = createSlice({
  name: 'listGroupPolicy',
  initialState: initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<IGroupPolicySearchParams>) {
      state.searchValue = action.payload;
    },
    setListIdDelete(state, action: PayloadAction<number[]>) {
      state.listIdDelete = action.payload;
    },
    setShowPopup(state, action: PayloadAction<boolean>) {
      state.showPopup = action.payload;
    },
  },
});

export const { setSearchValue, setListIdDelete, setShowPopup } =
  listGroupPolicyReducer.actions;

export const searchValue = (state: RootState) => state.listGroupPolicy.searchValue;
export const listIdDelete = (state: RootState) => state.listGroupPolicy.listIdDelete;
export const showPopup = (state: RootState) => state.listGroupPolicy.showPopup;

export default listGroupPolicyReducer.reducer;
